import get from "lodash.get";

export function visitFrequencyFormatter(cell, row) {
  let visitFrequency = get(row, "attributes.answersJson.visitFrequency", "");
  return visitFrequency ? visitFrequency : "N/A";
}
